module.exports = __webpack_public_path__ + "static/UnclickTripCancelled-27842d69e354111170995e6843daa375.png";